import { CloseOutlined as CrossIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import classnames from "classnames";
import React from "react";
import styles from "./upload-preview.module.scss";

function UploadPreview(props) {
  const { onImageRemoved = () => {}, attachments } = props;

  const handleRemoval = index => {
    onImageRemoved(index);
  };

  return (
    <div className={styles["upload-preview"]}>
      <div className={styles["upload-preview__container"]}>
        {attachments.map((preview, index) => (
          <div key={preview.file.name} className={styles["upload-preview__preview"]}>
            <div className={styles["upload-preview__preview-image-wrapper"]}>
              <img
                className={classnames(styles["upload-preview__preview-image"], "sessioncamexclude")}
                id={`attachment-${index}`}
                alt={`preview of your attachment named ${preview.file.name}`}
                src={preview.imagePreviewUrl}
              />
              <button
                type="button"
                onClick={handleRemoval.bind(this, preview.file.name)}
                className={styles["upload-preview__close-button"]}
              >
                <div className={styles["upload-preview__preview-cross-container"]}>
                  <CrossIcon className={styles["upload-preview__preview-black-cross"]} />
                </div>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UploadPreview;
